import React, {Component} from 'react';
import styled from "styled-components"
import {BasicButton} from "./PersonalDataCardButtons";
import navigateSVG from "../static/img/navigate.svg";

const NavigateButton = styled(BasicButton)`
  width: 250px;
  background-color: #2A7ECC;
  position: absolute;
  bottom: 1.5rem;
  right: 2rem;
  img{
  left: 20%;
  }
  span{
  left: 33%;
  }
`

class NavigateToCoordsButton extends Component {
    render() {
        return (
            <NavigateButton onClick={() => {
                const url = `
                        https://www.google.com/maps/dir/?api=1&\
destination=${this.props.lat},${this.props.lng}&\
travelmode=driving\
                        `
                window.open(url, '_blank')
            }}>

                <img src={navigateSVG} alt="navigate" draggable={false}/>
                <span>navigate</span>
            </NavigateButton>
        );
    }
}

export default NavigateToCoordsButton;